// extracted by mini-css-extract-plugin
export default {"label_title":"css-FaZiRGm+sp","label__error":"css-jh611ofQld","select":"css-oCc5WhkgyU","select__country":"css-JcZD3a6pT+"};